<p-dialog [(visible)]="display" [modal]="true" [closable]="true" [header]="header" [style]="{width: '50vw'}" [dismissableMask]="true">
    <ng-content></ng-content> <!-- This will allow any content to be passed into the modal -->
</p-dialog>